// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"VXyxG2","container":"NcFpE8","error":"EJll5a","hover":"BJSdrw"};